// 救援类型：乘用车/商用车，区分类型是因为计费策略不一样

import { Partner } from "./partners";
import { Dispatcher, Driver, Inspector, Surveyor } from "./users";

// Serve.Type
export const ServeTypePassenger = 0; // 乘用车
export const ServeTypeCommercial = 1; // 商用车

export const ServeTypes = ["乘用车", "商用车"];
export const ServeModes = ["事故救援", "非事故救援"];
export const SrDifficulties = ["一般难度", "较大难度", "其他难度"];

export const ADD = 0; // 添加服务项
export const UPDATE = 1; // 添加服务项
export const DELETE = 2; // 添加服务项

export const ITEM_BASEMENT = 1;
export const ITEM_CRANE = 2;
export const ITEM_HS = 3;
export const ITEM_SR = 4;
export const ITEM_VT = 5;
export const ITEM_WHEEl = 6;
export const ITEM_OIL = 9;//送油
export const ITEM_ELECTRIFY = 10;//搭电
export const ITEM_TYRE = 11;//换轮胎
export const ITEM_CRANE1 = 12;
export const ITEM_DR = 13;//困境救援
export const ITEM_OTHER = 255;//其他服务项目

export const Crane1ItemCodes = [
  "8T",
  "12T",
  "16T",
  "25T",
  "50T",
  "75T",
  "100T",
];

export const PictureNames = [
  "",
  "报案照片", // 1
  "现场正前方照片", // 2
  "现场左前方照片", // 3
  "现场右前方照片", // 4
  "现场正后方照片", // 5
  "现场左后方照片", // 6
  "现场右后方照片", // 7

  "受损照片", // 8
  "车架号照片", // 9
  "牵引方式照片", // 10
  "斜板固定照片", // 11
  "其他固定照片", // 12
  "背车正后方照片", // 13

  "辅助轮左边照片", // 14
  "辅助轮右边照片", // 15

  "现场救援照片", // 16

  "送达地门头照片", // 17
  "送达地卸车照片", // 18

  "客户驾驶证正本照片", // 19
  "客户驾驶证副本审核也照片", // 20
  "行驶证正本照片", // 21
  "行驶证副本审核页照片", // 22
  "年审标志背面照片", // 23
  "客户银行卡正面照片", // 24
  "客户银行卡背面照片", // 25
  "客户身份证国徽面照片", // 26
  "客户身份证人像面照片", // 27

  // "回单照片",//28 弃用
];

// key 是 PictureNames对应的下标，值是数量
// 例如：
// key为1，value为1，则代表现场正前方照片需要一张。
export const PhotoRequirements = new Map<number, number>([
  [1, 1], // 报案图片不需要小程序采集
  [2, 1],
  [3, 1],
  [4, 1],
  [5, 1],
  [6, 0],
  [7, 0],
  [8, 6],
  [9, 1],
  [10, 1],
  [11, 1],
  [12, 2],
  [13, 1],
  [14, 1],
  [15, 1],
  [16, 6],
  [17, 1],
  [18, 1],
  [19, 1],
  [20, 1],
  [21, 1],
  [22, 1],
  [23, 0],
  [24, 1],
  [25, 1],
  [26, 1],
  [27, 1],
]);

// Participants 服务参与人
export type Participants = {
  provider: number;
  surveyor: number;
  providerInspector: number;
  providerOutNo: string;
  driver: number;
  driverCompany: number;
  driverInspector: number;
  requestCode: string//订单流水号，单一订单唯一标识,新增用于后端标记人事故救援
};

// Client 客户和车辆信息
export type Client = {
  id: number;
  sid: string;
  name: string;
  gender: number;
  phone: string;
  color: string;
  license: string;
  brand: string;
  size: number;
};

export type Picture = {
  id: number;
  sid: string;
  oid: string;
  matter: number;
  createdAt: number;
};

export type Location = {
  id: number;
  sid: string;
  pair: string;
  matter: number;
  type: number;
  longitude: string;
  latitude: string;
  province: string;
  city: string;
  district: string;
  address: string;
  name: string;
};

export type Serve = {
  id: number;
  sid: string;
  type: number;
  dispatcher: number;
  dispatcherCompany: number;

  driver: number;
  driverCompany: number;
  driverInspector: number;

  provider: number;
  providerOutNo: string;
  surveyor: number;
  providerInspectorr: number;

  pickupName: string;
  pickupPhone: string;

  status: number;
  statusText: string;

  paymentStatus: number;
  payer: number;

  createdAt: number;
  updatedAt: number;
};

export type TabledServe = {
  id: number;
  sid: string;
  license: string,
  feedback: boolean;
  driverCompany: string;
  driverCompanyId: number;
  provider: string;
  providerId: number;
  providerOutNo: string;
  status: number;
  statusText: string;
  createdAt: number;
  mode: number;
  items: Object;//服务项目列表
  paymentStatus: number//旧的判断支付状态的字段 ， 新的逻辑要使用type PayStatus中的字段判断
  checkedOut: boolean,//结算标记[0:未结算  1:已结算]
} & PayStatus;

export type PayStatus = {
  creditStatus: number,// '挂帐状态 [0:默认未挂账，1：已挂账]',
  paymentMode: number // ["仅允许线上支付", "仅允许挂帐", "允许混合付款", "不限制"];
  payStatus: number//   '线上支付状态 [0:默认未支付，1：已支付]',
}

export const PayModeMap = ["仅允许线上支付", "仅允许挂帐", "允许混合付款", "不限制"];
export const isComplate = (item: PayStatus) => {
  if (item.paymentMode === 0) {
    return item.payStatus === 1
  }
  else if (item.paymentMode === 1) {
    return item.creditStatus === 1;
  } else if (item.paymentMode === 2) {
    return item.payStatus === 1 && item.creditStatus === 1
  } else {
    // 不限制情况下，要么全支付 要么全付款 一半一半的情况下会被重置为混合付款
    return item.payStatus === 1 || item.creditStatus === 1
  }
}

export const SET_SERVICES = "SET_SERVICES";

export type Payment = {
  id: number;
  sid: string;
  payer: string;
  payerIp: string;
  totaFee: number;
  status: number;
  outTradeNo: string;
  transactionId: number;
  statedAt: number;
  comfirmedAt: number;
  outRefundNo: string;
  refundedAt: number;
  refundeRole: number;
  refundedId: number;
  refundedRemark: string;
};

export type ServeBrief = {
  sid: string;
  mode: number;
  type: number;
  providerOutNo: string;
  status: number;
  statusText: string;
  client: Client;
  locations: Location[];
  createdAt: number;
  updatedAt: number;
  driver: number;
  surveyor: number;
  pictures: Picture[];
  pickupName: string;
  pickupPhone: string;
  paymentStatus: number;
  totalFee: number;
  feedback:boolean
} & PayStatus;

export type ServeEvent = {
  id: number;
  sid: string;
  title: string;
  timestamp: number;
};

export type VT = {
  id: number;
  mode: number;
  sid: string;
  starting: number;
  destination: number;
  distance: number;
  startingFee: number;
  totalFee: number;
  createdAt: number;
  daytime?: number
};

export type Crane = {
  id: number;
  mode: number;
  sid: string;
  starting: number;
  destination: number;
  distance: number;
  totalFee: number;
  createdAt: number;
  daytime?: number
};

export type Crane1 = {
  id: number;
  sid: string;
  itemCode: number;
  starting: number;
  destination: number;
  distance: number;
  totalFee: number;
  createdAt: number;
  daytime?: number//无用字段
};

export type Basement = {
  id: number;
  mode: number;
  sid: string;
  totalFee: number;
  createdAt: number;
  daytime?: number//无用字段
};

export type HS = {
  id: number;
  mode: number;
  sid: string;
  totalFee: number;
  createdAt: number;
  daytime?: number//无用字段
};

export type SR = {
  id: number;
  mode: number;
  sid: string;
  difficulty: number;
  baseFee: number;
  labor: number;
  hours: number;
  distance: number;
  totalFee: number;
  createdAt: number;
  daytime?: number//无用字段
};

export type Wheel = {
  id: number;
  mode: number;
  sid: string;
  count: number;
  totalFee: number;
  createdAt: number;
  daytime?: number//无用字段
};

export type Oil = {
  id: number;
  mode: number;
  sid: string;
  starting: number;
  destination: number;
  distance: number;
  totalFee: number;
  createdAt: number;
  daytime?: number//无用字段
};

export type Electrify = {
  id: number;
  mode: number;
  sid: string;
  starting: number;
  destination: number;
  distance: number;
  totalFee: number;
  createdAt: number;
  daytime?: number//无用字段
};

export type Tyre = {
  id: number;
  mode: number;
  sid: string;
  starting: number;
  destination: number;
  distance: number;
  totalFee: number;
  createdAt: number;
  daytime?: number//无用字段
};

export type Trouble = {
  id: number;
  mode: number;
  sid: string;
  starting: number;
  destination: number;
  distance: number;
  totalFee: number;
  createdAt: number;
  daytime?: number//无用字段
};

export type OtherFee = {
  id: number;
  mode: number;
  sid: string;
  totalFee: number;
  remark: string;
  createdAt: number;
  daytime?: number//无用字段 仅仅是为了适配随车吊和车辆运输
};

export type ServiceItems = {
  basement?: Basement;
  crane?: Crane;
  crane1?: Crane1;
  vt?: VT[];
  hs?: HS;
  sr?: SR;
  wheel?: Wheel;
  oil?: Oil;
  electrify?: Electrify;
  tyre?: Tyre;
  dilemmaRescue?: Trouble;
  other?: OtherFee;
};

export type OneOfItems = Basement | Crane | VT | HS | SR | Wheel | Crane1 | Trouble | OtherFee;

export type Serving = {
  Brief: ServeBrief;
  Items: ServiceItems;
  Pictures: Picture[];
  Mode: number;
  Editor: React.FC<{
    serving: Serving;
    onSubmit: <T>(args: OpItems<any>) => Promise<T>;
  }>;
};

export type OpItems<T> = {
  action: number;
  item: T;
  sid: string;
  type: number;
  daytime?: number
};

export type OpPictureResult = {
  status?: number;
  statusText?: string;
  pictures: Picture[];
  event?: ServeEvent;
};

export type UnifiedOrderResult = {
  appid: string;
  package: string;
  paySign: string;
  nonceStr: string;
  signType: "MD5";
  timeStamp: string;
  outTradeNo: string;
};

export type QueryOrderResult = {
  serve: Serve;
  payment: Payment;
  event?: ServeEvent;
};

// 服务相关方
export type ServiceRelated = {
  sid: string;
  dispatcher: Dispatcher;
  dispatcherCompany: Partner;
  driver: Driver;
  driverCompany: Partner;
  driverInspector?: Inspector;
  provider: Partner;
  providerInspector?: Inspector;
  surveyor?: Surveyor;
};

export type ServiceDetails = {
  brief: ServeBrief;
  events: ServeEvent[];
  locations: Location[];
  participants: ServiceRelated;
  pictures: Picture[];
  items: ServiceItems;
};

export type Remark = {
  id: number;
  sid: string;
  name: string;
  text: string;
  createdAt: number;
};

// 高德地图坐标数据格式
export type AMapWD = {
  KL: number,
  className: string
  kT: number
  lat: number
  lng: number
  pos: number[]
}

// 高德地图搜索的地图数据格式
export type AMapLocationType = {
  adcode: string,
  address: string
  city: []
  district: string
  id: string
  location: AMapWD
  name: string
  typecode: string
}

// 地图路径信息存储传参
export type MapPathSaveArgsType = {
  map: number,//0高德地图 1是腾讯 2百度
  sid: string,//服务ID
  item: number,//服务编号
  itemId: number,//服务项目的id
  origin: number, //位置id 起始地id
  destination: number,// 位置id 目的地id
  routesJsonAll: string,//所有的path 序列化json
  routesJsonSelected: string//选中的path 序列化json
}


export type AmapNaviationPath = {
  distance: string;
  duration: string;
  restriction: string;
  steps: { polyline: string, instruction: string }[];
  strategy: string;
  toll_distance: number;
  tolls: number;
  trafic_lights: number;
}

export type DistanceType = {
  distance: number;
  selected: AmapNaviationPath | null,
  paths: AmapNaviationPath[];
}

export const MODE_CHANGE_EVENT: string = "CHANGE_MODE";

// 服务项目配置对应关系
const names: [number, string][] = [
  [ITEM_BASEMENT, "地库救援"],
  [ITEM_CRANE, "随车吊"],
  [ITEM_HS, "高速救援附加费"],
  [ITEM_SR, "现场救援"],
  [ITEM_VT, "车辆运输"],
  [ITEM_WHEEl, "辅助轮"],
  [ITEM_OIL, "送油"],
  [ITEM_ELECTRIFY, "搭电"],
  [ITEM_TYRE, "换胎"],
  [ITEM_CRANE1, "吊车"],
  [ITEM_DR, "困境救援"],
  [ITEM_OTHER, "其他费用"],
];

export const ItemNames = new Map<number, string>(names);

// 数据库返回的服务项目配置
export type ServiceItemConfig = {
  id: number;
  partner: number;
  config: string;
};

// 解析后的服务项目配置数据格式
export type ItemConfig = {
  item: number;
  mode: number;
  itemName: string;
  modeName: string;
  enabled: boolean;
};

// 解析后的服务项目配置数据格式
export const OtherItem: ItemConfig = {
  item: ITEM_OTHER,
  mode: 0,
  itemName: '其他费用',
  modeName: '其他',
  enabled: true
};

// 其他费用
export const OtherFeeRemark: string[] = [
  '事故转非事故',
  '客户诉求',
  '保险公司要求补单'
]

export type StatisticsDataType = {
  creditedFee: number,// 已挂账
  creditedTotalFee: number,// 挂账总数
  noCreditFee: number,// 未挂账
  paidFee: number,//已支付
  payTotalFee: number,//支付总数
  unpaidFee: number,//未支付

  creditedNumber: number,
  creditedTotalNumber: number,
  noCreditNumber: number,
  paidNumber: number,
  payTotalNumber: number,
  unpaidNumber: number,
}